module.exports = {"150425100":"经棚镇","150425101":"宇宙地镇","150425102":"土城子镇","150425103":"同兴镇","150425104":"万合永镇","150425105":"芝瑞镇","150425106":"达来诺日镇","150425200":"新开地乡","150425201":"红山子乡","150425202":"达日罕乌拉苏木","150425203":"巴彦查干苏木","150425204":"浩来呼热苏木","150425205":"乌兰布统苏木","150425400":"应昌街道","150425401":"热水塘温泉疗养旅游开发区管委会","150425402":"克什克腾旗煤电化基地","150425403":"西拉沐沦街道","150425502":"克什克腾旗渔场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/150425.json
// module id = 422
// module chunks = 0